import React from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Descriptions, Avatar } from 'antd';
import { loginUser } from '../../Redux/actions/authActions'


class Inspect extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        const { visible, disableModal, inspectValue, handleOk } = this.props
        return (
            <div>
                <Modal
                    visible={visible}
                    title="Promotion Ad's"
                    onOk={handleOk}
                    onCancel={disableModal}
                    footer={[
                        <Button key="back" onClick={disableModal}>
                            Return
                    </Button>,
                        <Button key="submit" type="primary" onClick={handleOk}>
                            Approve
                    </Button>,
                    ]}
                >
                    <Descriptions title="Promotion Ad's Detail" column={1} layout="horizontal" bordered>
                        <Descriptions.Item label="Name">{inspectValue.name}</Descriptions.Item>
                        <Descriptions.Item label="Bid/day">{inspectValue.bid}</Descriptions.Item>
                        <Descriptions.Item label="Budget">${inspectValue.budget}</Descriptions.Item>
                        <Descriptions.Item label="Start Date">{inspectValue.startDate}</Descriptions.Item>
                        <Descriptions.Item label="End Date">{inspectValue.endDate}</Descriptions.Item>
                        <Descriptions.Item label="Description Ad-campaign">{inspectValue.description}</Descriptions.Item>
                        <Descriptions.Item label="Image">
                            <Avatar src={inspectValue.image.url} size={100} />
                        </Descriptions.Item>
                    </Descriptions>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.authReducer.user,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loginUser: (user) => dispatch(loginUser(user)),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(Inspect)